import { Document, Page, Text, View } from "@react-pdf/renderer";
import { styles } from "..";
import moment from "moment";

const OCAF = ({ printData, printedName }) => {
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const patinetInfo = printData?.patient;

  const coveragePersonal = printData?.coverage_info;
  const payerPersonal = printData?.payer_response;
  const visitTimeDate = moment(payerPersonal?.requestat).format(
    "DD-MM-YYYY , hh:MM A"
  );
  return (
    <Document>
      <Page size="A3" style={styles.page}>
        <Text style={styles.heading}>ocaf 2.0</Text>
        <View style={styles.flexRow}>
          <View style={styles.cardStyle}>
            <Text style={styles.title}>
              To be completed by the reception/nurse:
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Provider Name: </Text>
              <Text style={styles.s1textvalue}>
                {selectedBranch?.branch_name || "-"}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Insurance Company Name: </Text>
              <Text style={styles.s1textvalue}>
                {printData?.insurance_name || "-"}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>TPA Company Name: </Text>
              <Text style={styles.s1textvalue}>{"-"}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Patient File Number: </Text>
              <Text style={styles.s1textvalue}>{patinetInfo?.patient_mrn}</Text>
            </Text>
            <View style={styles.flexRow}>
              <Text style={styles.checkItem}>
                Single {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Married {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Plan Type {"(  "}
                {")"}
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date of visit: </Text>
              <Text style={styles.s1textvalue}>{visitTimeDate}</Text>
            </Text>
            <View style={styles.flexRow}>
              <Text style={styles.checkItem}>
                New visit {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Follow Up {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Refill {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Walk In {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Referral {"(  "}
                {")"}
              </Text>
            </View>
          </View>
          <View style={styles.cardStyle}>
            <Text style={styles.title}>
              Print/Fill in clear letters or Emboss Card:
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Insurance Name: </Text>
              <Text style={styles.s1textvalue}>
                {`${patinetInfo?.patient_firstname || ""} ${
                  patinetInfo?.patient_familyname
                }`}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>National ID / Iqama : </Text>
              <Text style={styles.s1textvalue}>
                {patinetInfo?.patient_nationalid}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>ID. Card No. : </Text>
              <Text style={styles.s1textvalue}>
                {coveragePersonal?.memberid}
              </Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Sex : </Text>
                <Text style={styles.s1textvalue}>{patinetInfo?.gender}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>DOB : </Text>
                <Text style={styles.s1textvalue}>
                  {patinetInfo?.patient_dob}
                </Text>
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Policy Holder : </Text>
              <Text style={styles.s1textvalue}>
                {patinetInfo?.sponsor_name}
              </Text>
            </Text>

            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Policy No. : </Text>
                <Text style={styles.s1textvalue}>
                  {patinetInfo?.sponsor_no}
                </Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Expiry Date : </Text>
                <Text style={styles.s1textvalue}>
                  {payerPersonal?.serviceto}
                </Text>
              </Text>
            </View>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Class : </Text>
                <Text style={styles.s1textvalue}>
                  {coveragePersonal?.class}
                </Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Status : </Text>
                <Text style={styles.s1textvalue}>
                  {printData?.eligibility_status || "-"}
                </Text>
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Eligibility Ref. NO : </Text>
              <Text style={styles.s1textvalue}>
                {payerPersonal?.reference_no || "-"}
              </Text>
            </Text>
          </View>
        </View>

        <View style={styles.card}>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Consult. Free Max Limit : </Text>
              <Text
                style={styles.s1textvalue}
              >{`${coveragePersonal?.maxlimit} SAR`}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Deductible : </Text>
              <Text
                style={styles.s1textvalue}
              >{`${coveragePersonal?.deductable} %`}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>To be Collected : </Text>
              <Text style={styles.s1textvalue}></Text>
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval Limit : </Text>
              <Text style={styles.s1textvalue}></Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Deductible Desc : </Text>
              <Text style={styles.s1textvalue}></Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}></Text>
              <Text style={styles.s1textvalue}></Text>
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}></Text>
              <Text style={styles.s1textvalue}></Text>
            </Text>
          </View>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Special Member Info : </Text>
            <Text style={styles.s1textvalue}></Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Special Coverage Info : </Text>
            <Text style={styles.s1textvalue}></Text>
          </Text>
        </View>

        <View style={styles.card}>
          <Text style={styles.title}>To be Completed by the Optician</Text>
          <View style={styles.flexRow}>
            <View style={styles.cardStyle}>
              <View style={[styles.gridContainer, styles.tableRow]}>
                {/* Header Row */}
                <View style={[{ width: "15%" }]}>
                  <Text></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>RIGHT EYE</Text>
                </View>

                {/* Column Labels */}
              </View>
              <View style={[styles.gridContainer, styles.tableRow]}>
                {/* Header Row */}
                <View style={[{ width: "15%" }]}>
                  <Text></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>Sphere</Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>Cylinder</Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.5, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>Axis</Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.75, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>Prism</Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>V/N</Text>
                </View>

                {/* Column Labels */}
              </View>
              <View style={[styles.gridContainer, styles.tableRow]}>
                {/* Header Row */}
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { width: "15%", borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text> Distance </Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.5, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.75, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>

                {/* Column Labels */}
              </View>
              <View style={[styles.gridContainer, styles.tableRow]}>
                {/* Header Row */}
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { width: "15%", borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text> Near </Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.5, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.75, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>

                {/* Column Labels */}
              </View>
            </View>
            <View style={styles.cardStyle}>
              <View style={[styles.gridContainer, styles.tableRow]}>
                {/* Header Row */}
                <View style={[{ width: "15%" }]}>
                  <Text></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>LEFT EYE</Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    {
                      width: "10%",
                      borderLeft: "0.7px solid #999",
                      borderBottom: "0px solid #999",
                    },
                  ]}
                >
                  <Text style={styles.s1textValue}>PD</Text>
                </View>

                {/* Column Labels */}
              </View>
              <View style={[styles.gridContainer, styles.tableRow]}>
                {/* Header Row */}
                <View style={[{ width: "15%" }]}>
                  <Text></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>Sphere</Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>Cylinder</Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.5, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>Axis</Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.75, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>Prism</Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}>V/N</Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    {
                      width: "10%",
                      borderLeft: "0.7px solid #999",
                      borderTop: "0px solid #999",
                    },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>

                {/* Column Labels */}
              </View>
              <View style={[styles.gridContainer, styles.tableRow]}>
                {/* Header Row */}
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { width: "15%", borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text> Distance </Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.5, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.75, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>

                {/* Column Labels */}
              </View>
              <View style={[styles.gridContainer, styles.tableRow]}>
                {/* Header Row */}
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { width: "15%", borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text> Near </Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.5, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 0.75, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>
                <View
                  style={[
                    styles.cell,
                    styles.cell1,
                    styles.roundedBorder,
                    { flex: 1, borderLeft: "0.7px solid #999" },
                  ]}
                >
                  <Text style={styles.s1textValue}></Text>
                </View>

                {/* Column Labels */}
              </View>
            </View>
          </View>
          <View style={[styles.flexRow, { marginTop: 5 }]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Regular Lenses Type: </Text>
              <Text style={styles.s1textvalue}> {"  "}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Glass: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Plastic: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>None: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
          </View>
          <View style={[styles.flexRow, { marginTop: 5 }]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}> Lenses Specification: </Text>
              <Text style={styles.s1textvalue}> {"  "}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Multi-coated: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Medium: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Anti-reflecting coating: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
          </View>
          <View style={[styles.flexRow, { marginTop: 5 }]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}> </Text>
              <Text style={styles.s1textvalue}> {"  "}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Varilux: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Lenticular: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Photosensitive: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
          </View>
          <View style={[styles.flexRow, { marginTop: 5 }]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}> </Text>
              <Text style={styles.s1textvalue}> {"  "}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Light: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Single Version: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>High Index: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
          </View>
          <View style={[styles.flexRow, { marginTop: 5 }]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}> </Text>
              <Text style={styles.s1textvalue}> {"  "}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Aspheric: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Dark: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Colored: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
          </View>
          <View style={[styles.flexRow, { marginTop: 5 }]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}> {"  "} </Text>
              <Text style={styles.s1textvalue}> {"  "}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Bifocal: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Safety Thickness: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Anti-Scratch: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
          </View>
          <View style={[styles.flexRow, { marginTop: 5 }]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}> Contact Lenses Type: </Text>
              <Text style={styles.s1textvalue}> {"  "}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Permanent: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Disposal: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>{"  "}</Text>
              <Text style={styles.s1textvalue}> {"  "}</Text>
            </Text>
          </View>
          <View style={[styles.flexRow, { marginTop: 5 }]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}> Frames: </Text>
              <Text style={styles.s1textvalue}> {"  "}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Yes: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>No: </Text>
              <Text style={styles.s1textvalue}> ( {"  "})</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>{"  "}</Text>
              <Text style={styles.s1textvalue}> {"  "}</Text>
            </Text>
          </View>
        </View>
        <View style={[styles.flexRow]}>
          <View style={styles.cardStyle}>
            <Text style={styles.s1textvalue}>
              I hereby certify that ALL information mentioned are correct and
              that the medical services shown on this form were medically
              indicated and necessary for the management of this case.
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Physician: </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(70)}</Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Signature: </Text>
                <Text style={styles.s1textvalue}>{"."?.repeat(40)}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Date: </Text>
                <Text style={styles.s1textvalue}>
                  {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
                </Text>
              </Text>
            </View>
          </View>
          <View style={styles.cardStyle}>
            <Text style={styles.s1textvalue}>
              I hereby certify that ALL statements and information provided
              concerning patient identification and the present illness or
              injury are TRUE.
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Name (and relationship if guardian):{" "}
              </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(50)}</Text>
            </Text>
            <View style={[styles.flexRow, { marginTop: 5 }]}></View>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Signature(*) </Text>
                <Text style={styles.s1textvalue}></Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Date: </Text>
                <Text style={styles.s1textvalue}>
                  {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
                </Text>
              </Text>
            </View>
          </View>
        </View>

        <View style={styles.card}>
          <Text style={styles.s1textLabel}>
            *Provider's approval/coding staff must review/code recommended
            service(s) , allocated cost, and completed the following:
          </Text>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Total Cost: </Text>
              <Text style={styles.s1textLabel}>{"."?.repeat(50)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>As Estimated: </Text>
              <Text style={styles.s1textLabel}>( {"  "})</Text>
              <Text style={styles.s1textLabel}>Package Deal : </Text>
              <Text style={styles.s1textLabel}>({"  "})</Text>
            </Text>
          </View>
          <View style={styles.flexRow}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Completed / Coded by: </Text>
              <Text style={styles.s1textLabel}>{"."?.repeat(50)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Signature: </Text>
              <Text style={styles.s1textLabel}>{"."?.repeat(50)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date: </Text>
              <Text style={styles.s1textLabel}>
                {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
              </Text>
            </Text>
          </View>
        </View>
        <View style={styles.card}>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                For Insurance Company use Only
              </Text>
              <Text style={styles.s1textvalue}>
                Approved ( ) Not Approved ( )
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval No: {"  "}</Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(15)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval validity </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
          </View>
          <Text style={styles.s1textvalue}>
            Comments (include approved days/services if different from the
            requested)
          </Text>
          <Text style={[styles.s1textvalue, { paddingTop: 5 }]}>
            {"."?.repeat(100)}
          </Text>
          <View style={styles.flexRow}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Approved/Disapproved By {"  "}
              </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Signature {"  "}</Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date: </Text>
              <Text style={styles.s1textvalue}>
                {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
              </Text>
            </Text>
          </View>
        </View>
        <Text style={styles.s1textLabel}>
          (*) this is applicable only in case of manual UCAF{" "}
        </Text>

        <Text style={styles.createdBy} fixed>
          {`Printed by: | ${printedName || ""} ${moment().format("lll")}`}
        </Text>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber || ""} of ${totalPages || ""}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default OCAF;
